import { render, staticRenderFns } from "./EditStockDialog.vue?vue&type=template&id=16fc6446&scoped=true&"
import script from "./EditStockDialog.vue?vue&type=script&lang=js&"
export * from "./EditStockDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditStockDialog.vue?vue&type=style&index=0&id=16fc6446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc6446",
  null
  
)

export default component.exports